/** When your routing table is too long, you can split it into small modules **/

import Layout from '@/layout'

const AccountsRouter = {
  path: '/admin/accounts',
  component: Layout,
  redirect: '/admin/accounts/zoom/list',
  name: 'AccountManager',
  meta: {
    title: '帳密管理',
    icon: 'peoples',
    permissions: ['account-manager-view']
  },
  children: [
    {
      path: 'zoom',
      component: () => import('@/views/accounts/zoom/list'),
      name: 'ZoomList',
      meta: {
        title: 'Zoom教室帳密管理',
        icon: 'list',
        permissions: ['account-zoom-list-view']
      }
    },
    {
      path: 'teacher',
      component: () => import('@/views/accounts/teacher/list'),
      name: 'TeacherList',
      meta: {
        title: '老師帳號管理',
        icon: 'list',
        permissions: ['account-teacher-list-view']
      }
    },
    {
      path: 'student',
      component: () => import('@/views/accounts/student/list'),
      name: 'StudentList',
      meta: {
        title: '學生帳號管理',
        icon: 'list',
        permissions: ['account-student-list-view']
      }
    }
  ]
}
export default AccountsRouter
